import {createFormContext} from '@mantine/form';
import {IServicePosition} from "../types";

export const [ServicePositionsFormProvider, useFormContext, useServicePositionsForm] = createFormContext<IServicePosition>();
